import React from "react";
import PageShell from "../components/PageShell";
import FeaturedTires from "../components/FeaturedTires";
import TinderPneus from "../components/TinderPneus";

export default function PneusPage() {
  return (
    <PageShell testId="page-pneus">
      <FeaturedTires sidebar={<TinderPneus compact />} />
    </PageShell>
  );
}
